import React from "react";

export const Description = ({
  children,
  color = "gray",
  className: _class,
}) => {
  const className = `text-base text-${color} leading-8 ${_class}`;

  return <p className={className}>{children}</p>;
};
